import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class Leyenda extends Vue {
    @Prop() public colors!: string;
    @Prop() public asignedColors!: any;
    @Prop() public collaborativeAreasName!: any;

    public getColor(index: any){
        var colorIndex = this.asignedColors.findIndex((element: any) => element == index);
        return 'background-color: ' + this.colors[colorIndex];
    }

    public getCollaborativeAreaName(id: any) {
        var leyenda = this.collaborativeAreasName.find((element: any) => element.id == id);
        if(leyenda != undefined)
            return this.collaborativeAreasName.find((element: any) => element.id == id).name;
    }
}
